import { OnDestroy } from '@angular/core';
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/dot-notation */

import { Component, ComponentFactoryResolver, OnInit, Renderer2, ViewChild, ViewContainerRef } from '@angular/core';
import { ActivatedRoute,Router } from '@angular/router';
import { ContentService } from 'src/app/services/content.service';
import { Title, Meta } from '@angular/platform-browser';

@Component({
  selector: 'app-page',
  templateUrl: './page.page.html',
  styleUrls: ['./page.page.scss'],
})
export class PagePage implements OnInit, OnDestroy {
  @ViewChild('container', { read: ViewContainerRef, static: true })
  container: ViewContainerRef;

  pageUrl: any;
  page: string;
  pageArray = [];
  codeArray = [];
  blockArray = [];

  constructor(
    private actRoute: ActivatedRoute,
    private contentService: ContentService,
    private router: Router,
    private componentFactoryResolver: ComponentFactoryResolver,
    private renderer: Renderer2,
    private titleService: Title,
    private metaService: Meta
  ) {

   }

  ngOnInit() {
    this.pageUrl = this.actRoute.snapshot.paramMap.get('pageUrl');
    // console.log('url: ' + this.pageUrl);
    this.contentService.viewPageByURL(this.pageUrl).subscribe(res => {
      this.pageArray = res;

      this.contentService.getTemplate(this.pageArray[0]['template']).subscribe(res2 => {
        this.page = res2['body'];
        this.page = this.page.replace('[[mainContent]]',this.pageArray[0]['body']);
        this.codeArray = this.page.split('\n');
        // this.page = this.page.replace('{block1}','block1 replaced');
        // this.page = this.page.replace('{random}','random replaced');

        for (const value of this.codeArray) {
          if (value.match('\{(.*?)\}') !== null) {
            const block = value.match('\{(.*?)\}');
            this.blockArray.push(block[1]);
          };
        }

        // console.log(this.blockArray);
        for (const block of this.blockArray) {
          // this.insertBlock(block, this.page);
          this.contentService.getBlock(block).subscribe(res3 => {
            const blockArray = res3;
            if (blockArray[0]) {
              this.page = this.page.replace('<p>{' + block + '}</p>',blockArray[0]['body']);
            }
            // console.log(this.page);
          });
          this.contentService.getBlock(block).subscribe().unsubscribe();
        }

        if (this.pageArray[0]['metaTitle'] === '' || this.pageArray[0]['metaTitle'] == null) {
          this.getHomePageTitle();
        } else {
          this.titleService.setTitle(this.pageArray[0]['metaTitle']);
        }
        if (this.pageArray[0]['metaDescription'] === '' || this.pageArray[0]['metaDescription'] == null) {
          this.getHomePageDescription();
        } else {
          this.metaService.updateTag({ name: 'description', content: this.pageArray[0]['metaDescription'] });
        }
        // console.log(this.page);
        // console.log('id' + res2['id']);
      });
    });
  }

  ngOnDestroy(): void {
    //Called once, before the instance is destroyed.
    //Add 'implements OnDestroy' to the class.
    this.contentService.viewPageByURL(this.pageUrl).subscribe().unsubscribe();
  }

  getHomePageTitle() {
    this.contentService.viewPageByURL('home').subscribe(res => {
      const pageArray = res;
      this.titleService.setTitle(pageArray[0]['metaTitle']);
    });
  }

  getHomePageDescription() {
    this.contentService.viewPageByURL('home').subscribe(res => {
      const pageArray = res;
      this.metaService.updateTag({ name: 'description', content: pageArray[0]['metaDescription'] });
    });
  }

  insertBlock(codeword: string, html: string) {
    this.contentService.getBlock(codeword).subscribe(res => {
      const blockArray = res;
      this.page = html;
      this.page = this.page.replace('<p>{' + codeword + '}</p>',blockArray[0]['body']);
      // console.log(this.page);
    });
    this.contentService.getBlock(codeword).subscribe().unsubscribe();
  }

}
